import React from 'react';
import { Download, Upload } from 'lucide-react';

export default function Step1Operacao({ setOperation, setStep }) {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className="text-center mb-8 animate-fade-in">
        <h3 className="text-xl font-bold text-gray-800 mb-1">O que você deseja fazer agora?</h3>
        <p className="text-sm text-gray-500">Selecione o tipo de operação para iniciar o registro.</p>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-stretch gap-4 w-full max-w-lg">
        {/* Card Entrada */}
        <div
          onClick={() => { setOperation('entrada'); setStep(2) }}
          className="group relative flex-1 flex flex-col items-center justify-center p-6 bg-white border-2 border-[#00A415] hover:bg-[#00A415] text-[#00A415] hover:text-white rounded-xl shadow-sm hover:shadow-md cursor-pointer transition-all duration-300"
        >
          <Download size={36} className="mb-2 group-hover:scale-110 transition-transform duration-300" />
          <h3 className="text-lg font-semibold mb-1">Entrada</h3>
          <p className="text-xs opacity-80 text-center font-medium">Receber material</p>
          <div className="absolute top-3 right-3 bg-gray-100 group-hover:bg-[#008a11] text-gray-600 group-hover:text-white text-[10px] font-bold px-2 py-1 rounded-full transition-colors">
            F3
          </div>
        </div>

        {/* Card Saída */}
        <div
          onClick={() => { setOperation('saida'); setStep(2) }}
          className="group relative flex-1 flex flex-col items-center justify-center p-6 bg-white border-2 border-[#FD4D4C] hover:bg-[#FD4D4C] text-[#FD4D4C] hover:text-white rounded-xl shadow-sm hover:shadow-md cursor-pointer transition-all duration-300"
        >
          <Upload size={36} className="mb-2 group-hover:scale-110 transition-transform duration-300" />
          <h3 className="text-lg font-semibold mb-1">Saída</h3>
          <p className="text-xs opacity-80 text-center font-medium">Entregar material</p>
          <div className="absolute top-3 right-3 bg-gray-100 group-hover:bg-[#d63a39] text-gray-600 group-hover:text-white text-[10px] font-bold px-2 py-1 rounded-full transition-colors">
            F4
          </div>
        </div>
      </div>
    </div>
  );
}
